import { RouteDirection } from '../../../constants/RouteDirection'

export class Route {
  constructor(
    public readonly routerId: string,
    public readonly distance: string,
    public readonly direction: RouteDirection|string,
  ) {}
}
